import React from 'react'
import { Navigate, NavigateProps, useLocation } from 'react-router-dom'

import { routes } from '~constants/routes'
import { useAuth } from '~lib/auth'

interface PrivateElementProps {
  /**
   * Route to redirect to when user is not authenticated. Defaults to
   * `LOGIN_ROUTE` if not provided.
   */
  redirectTo?: NavigateProps['to']
  children: React.ReactNode
}

export const PrivateElement = ({
  children,
  redirectTo = routes.login,
}: PrivateElementProps): React.ReactNode => {
  const location = useLocation()

  const { isAuthenticated } = useAuth()

  if (isAuthenticated) {
    return children
  }

  return <Navigate replace to={redirectTo} state={{ from: location }} />
}
